// Dev-preview mode voor de signup-flow.
// Wanneer actief: alle Firebase-writes worden overgeslagen, navigatie en
// form-validatie werken wel zodat de UI/design getest kan worden.
//
// Activeren:
//   - Bezoek `/signup?dev=1` → wordt opgeslagen in localStorage zodat het
//     persist over navigatie (URL-param verdwijnt bij history.push).
//   - Of zet handmatig: `localStorage.setItem('onboarding_dev_preview', '1')`
//
// Deactiveren:
//   - `/signup?dev=0` → wist localStorage
//   - Of via de "Verlaat dev preview" knop in de banner
//   - Of: `localStorage.removeItem('onboarding_dev_preview')`

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const STORAGE_KEY = 'onboarding_dev_preview'

const readStorage = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
        return false
    }
}

const useDevPreview = () => {

    const location = useLocation()
    const [active, setActive] = useState(readStorage)

    // Sync URL-param naar localStorage bij elke navigatie
    useEffect(() => {

        const params = new URLSearchParams(location.search)
        const devParam = params.get('dev')

        if (devParam === '1') {
            try { localStorage.setItem(STORAGE_KEY, '1') } catch {}
            setActive(true)
        } else if (devParam === '0') {
            try { localStorage.removeItem(STORAGE_KEY) } catch {}
            setActive(false)
        }

    }, [location.search])

    const disable = () => {
        try { localStorage.removeItem(STORAGE_KEY) } catch {}
        setActive(false)
    }

    return { active, disable }

}

export default useDevPreview
